import { Formik } from "formik";
import React, { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import BasicSelect from "../BasicSelect";
import LoadButton from "../LoadButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setQuery } from "../../store/reducers/query";
import { isAdmin, isAdminSrmanager, status } from "../../utils/menuItems";
import dayjs from "dayjs";
import CustomRadio from "../CustomRadio";
import MultiSelect from "../MultiSelect";
import { useGetProjectsDataQuery } from "../../store/services/project";

const LeadAdForm = ({ handleClose, users }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.auth);
  // const { users } = useSelector((state) => state.users);

  const { data: projectsData, isFetching: isFetchingProjects } =
    useGetProjectsDataQuery({
      page: 1,
      limit: Number.MAX_SAFE_INTEGER,
    });
  const projectList = projectsData?.data.map((itm) => ({
    label: itm?.projectName,
    value: itm._id,
  }));

  const { query } = useSelector((state) => state.query);
  const agent = auth?.role === "agent";
  const teamLeadAgent = auth?.role === "team_lead" || auth?.role === "agent";
  const AMTeamLeadAgent = teamLeadAgent || auth?.role === "assistant_manager";
  const ManagerAMTeamLeadAgent = AMTeamLeadAgent || auth?.role === "manager";
  const SrmManagerAMTeamLeadAgent =
    ManagerAMTeamLeadAgent || auth?.role === "sr_manager";

  const [values, setValues] = useState({
    // type: query?.type ? query?.type : "lead",
    status: query?.status ? query?.status : [],
    startDate: query?.startDate
      ? dayjs(query?.startDate).startOf("day")
      : dayjs(Date.now()).subtract(2, "days").startOf("day"),
    endDate: query?.startDate
      ? dayjs(query?.endDate).endOf("day")
      : dayjs(Date.now()),
    srManager: query?.srManager ? query?.srManager : [],
    manager: query?.manager ? query?.manager : [],
    assistantManager: query?.assistantManager ?? [],
    teamLead: query?.teamLead ? query?.teamLead : [],
    agent: query?.agent ? query?.agent : [],
    individual: query?.individual ?? "false",
    exclude: {
      srManager: query?.exclude?.srManager ?? false,
      manager: query?.exclude?.manager ?? false,
      assistantManager: query?.exclude?.assistantManager ?? false,
      teamLead: query?.exclude?.teamLead ?? false,
    },
    teamOption: {
      srManager: query?.teamOption?.srManager ?? false,
      manager: query?.teamOption?.manager ?? false,
      assistantManager: query?.teamOption?.assistantManager ?? false,
      teamLead: query?.teamOption?.teamLead ?? false,
    },
    teamId: query?.teamId ? query?.teamId : undefined,
    dateKey: query?.dateKey ? query?.dateKey : "createdAt",
    projectId: query?.projectId ? query?.projectId : [],
    source: query?.source ? query?.source : "",
  });

  return (
    <Formik
      initialValues={values}
      onSubmit={async (values) => {
        setLoading(true);
        try {
          dispatch(setQuery({ values, type: "lead" }));
          // setLoading(false);
          // if (type === `lead/filterLeads/fulfilled`) {
          navigate(`/leads`);
          //   //popup Close
          handleClose();
          // }
        } catch (err) {
          console.log("err", err);
        }
        setLoading(false);
      }}
    >
      {({ values, handleChange, setFieldValue, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Grid container rowSpacing={3} columnSpacing={3} mt={0}>
            {![...isAdmin, "agent"].includes(auth?.role) && (
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 18,
                    mb: 1,
                    fontWeight: 500,
                    color: "#000000",
                  }}
                >
                  Teams Option
                </Typography>
                <CustomRadio
                  items={[
                    { value: true, label: "My Leads" },
                    { value: false, label: "Teams Lead" },
                  ]}
                  value={values.individual}
                  handleChange={handleChange}
                  name={"individual"}
                  size={"small"}
                  row
                />
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Date Filter By
              </Typography>
              <BasicSelect
                value={values.dateKey}
                name={"dateKey"}
                size="small"
                handleChange={handleChange}
                items={[
                  { label: "Creation Time", value: "createdAt" },
                  { label: "Updation Time", value: "updatedAt" },
                ]}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Start Date
              </Typography>
              <DatePicker
                value={values.startDate}
                onChange={(newValue) => setFieldValue("startDate", newValue)}
                sx={{ width: "100%" }}
                placeholder="start"
                format="DD/MM/YYYY"
                slotProps={{
                  field: {
                    size: "small",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                End Date
              </Typography>
              <DatePicker
                value={values.endDate}
                onChange={(newValue) => setFieldValue("endDate", newValue)}
                sx={{ width: "100%" }}
                placeholder="start"
                format="DD/MM/YYYY"
                slotProps={{
                  field: {
                    size: "small",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Status
              </Typography>
              <MultiSelect
                value={values.status}
                name={"status"}
                // size="small"
                handleChange={setFieldValue}
                items={status}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Project
              </Typography>
              <MultiSelect
                value={values.projectId}
                name={"projectId"}
                // size="small"
                handleChange={setFieldValue}
                items={projectList}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography
                sx={{
                  fontSize: 18,
                  mb: 1,
                  fontWeight: 500,
                  color: "#000000",
                }}
              >
                Source
              </Typography>
              <TextField
                name="source"
                value={values.source}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            {/* {console.log("207", values.individual)} */}
            {values.individual === "false" && (
              <>
                {isAdminSrmanager.includes(auth?.role) && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Stack
                      direction="row"
                      spacing={5}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 18,
                          mb: 1,
                          fontWeight: 500,
                          color: "#000000",
                        }}
                      >
                        Sr Manager
                      </Typography>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("teamOption", {
                                  ...(values.teamOption || {}),
                                  srManager: e.target.checked,
                                })
                              }
                              checked={values.teamOption.srManager}
                            />
                          }
                          label="Team"
                        />
                        {values.teamOption?.srManager && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="12px"
                                onChange={(e) =>
                                  setFieldValue("exclude", {
                                    ...(values.exclude || {}),
                                    srManager: e.target.checked,
                                  })
                                }
                                checked={values.exclude.srManager}
                              />
                            }
                            label="User Exclude"
                          />
                        )}
                      </div>
                    </Stack>

                    <MultiSelect
                      value={values.srManager}
                      name={"srManager"}
                      // size="small"
                      handleChange={setFieldValue}
                      items={users?.["sr_manager"]}
                    />
                  </Grid>
                )}

                {!ManagerAMTeamLeadAgent && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Stack
                      direction="row"
                      spacing={5}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 18,
                          mb: 1,
                          fontWeight: 500,
                          color: "#000000",
                        }}
                      >
                        Team Manager
                      </Typography>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("teamOption", {
                                  ...(values.teamOption || {}),
                                  manager: e.target.checked,
                                })
                              }
                              checked={values.teamOption.manager}
                            />
                          }
                          label="Team"
                        />
                        {values.teamOption?.manager && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="12px"
                                onChange={(e) =>
                                  setFieldValue("exclude", {
                                    ...(values.exclude || {}),
                                    manager: e.target.checked,
                                  })
                                }
                                checked={values.exclude.manager}
                              />
                            }
                            label="User Exclude"
                          />
                        )}
                      </div>
                    </Stack>
                    <MultiSelect
                      value={values.manager}
                      name={"manager"}
                      // size="small"
                      handleChange={setFieldValue}
                      items={users?.["manager"]}
                    />
                  </Grid>
                )}

                {!AMTeamLeadAgent && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Stack
                      direction="row"
                      spacing={5}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 18,
                          mb: 1,
                          fontWeight: 500,
                          color: "#000000",
                        }}
                      >
                        Assistant Manager
                      </Typography>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("teamOption", {
                                  ...(values.teamOption || {}),
                                  assistantManager: e.target.checked,
                                })
                              }
                              checked={values.teamOption.assistantManager}
                            />
                          }
                          label="Team"
                        />

                        {values.teamOption?.assistantManager && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="12px"
                                onChange={(e) =>
                                  setFieldValue("exclude", {
                                    ...(values.exclude || {}),
                                    assistantManager: e.target.checked,
                                  })
                                }
                                checked={values.exclude.assistantManager}
                              />
                            }
                            label="Exclude"
                          />
                        )}
                      </div>
                    </Stack>
                    <MultiSelect
                      value={values.assistantManager}
                      name={"assistantManager"}
                      // size="small"
                      handleChange={setFieldValue}
                      items={users?.["assistant_manager"]}
                    />
                  </Grid>
                )}

                {!teamLeadAgent && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Stack
                      direction="row"
                      spacing={5}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 18,
                          mb: 1,
                          fontWeight: 500,
                          color: "#000000",
                        }}
                      >
                        Team Lead
                      </Typography>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("teamOption", {
                                  ...(values.teamOption || {}),
                                  teamLead: e.target.checked,
                                })
                              }
                              checked={values.teamOption.teamLead}
                            />
                          }
                          label="Team"
                        />

                        {values.teamOption?.teamLead && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="12px"
                                onChange={(e) =>
                                  setFieldValue("exclude", {
                                    ...(values.exclude || {}),
                                    teamLead: e.target.checked,
                                  })
                                }
                                checked={values.exclude.teamLead}
                              />
                            }
                            label="Exclude"
                          />
                        )}
                      </div>
                    </Stack>
                    <MultiSelect
                      value={values.teamLead}
                      name={"teamLead"}
                      // size="small"
                      handleChange={setFieldValue}
                      items={users?.["team_lead"]}
                    />
                  </Grid>
                )}
                {!agent && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Stack
                      direction="row"
                      spacing={5}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 18,
                          mb: 1,
                          fontWeight: 500,
                          color: "#000000",
                        }}
                      >
                        Agents
                      </Typography>
                    </Stack>
                    <MultiSelect
                      value={values.agent}
                      name={"agent"}
                      // size="small"
                      handleChange={setFieldValue}
                      items={users?.["agent"]}
                    />
                  </Grid>
                )}
              </>
            )}

            <Grid item xs={12}>
              <LoadButton
                loading={loading}
                type="submit"
                variant="contained"
                color="custom"
                sx={{ width: "120px", marginBottom: "15px" }}
              >
                Apply
              </LoadButton>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default LeadAdForm;
